module.exports = __webpack_public_path__ + "static/media/to_finish_task.36d7ef10.svg";